export default {
  BASE_API_URL: "//filebe.services-money91.com/",
  FILE_UPLOAD_URL: "//filebe.services-money91.com/upload_file/",
  // BASE_API_URL: "//test4.services-money91.com/file91/",
  // FILE_UPLOAD_URL: "//test4.services-money91.com/upload_file/",
  PAYBOARD_URL: "//be.payboard.in/PayBoard/rest/user/"
  // BASE_API_URL_MALL: "https://groupbuybe.payboard.in/saleService"
};

export const getBase64Url = (file) => {
  var reader = new FileReader();
  reader.readAsDataURL(file);
  var base64 = new Promise(function (resolve, reject) {
    reader.onload = (event) => {
      if (event.target)
        resolve(event.target.result);
      else
        reject(new Error('fail'))
    };
  });
  return base64;
}